/* eslint-disable */

var TwirlShader = {

  uniforms: {

    "tDiffuse": { value: null },
    "opacity": { value: 1.0 },
    "amount": { value: 0.0 }

  },

  vertexShader: [

    "varying vec2 vUv;",

    "void main() {",

    " vUv = uv;",
    " gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );",

    "}"

  ].join( "\n" ),

  fragmentShader: [

    "uniform float opacity;",
    "uniform float amount;",
    "uniform sampler2D tDiffuse;",

    "varying vec2 vUv;",

    "void main() {",

    " vec2 uv = vUv - 0.5;",
    " float angle = atan(uv.y, uv.x);",
    " float radius = length(uv);",
    " angle += smoothstep(0.4, 0., radius) * amount * 0.5;",
    " vec2 shifted = radius * vec2(cos(angle), sin(angle));",
    " vec4 texel = texture2D( tDiffuse, shifted+0.5 );",
    " gl_FragColor = opacity * texel;",

    "}"

  ].join( "\n" )

};

export { TwirlShader };
